module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-person-bonus-card-railways">\n	<div class="l-grid-container">\n		<div class="l-grid-layout-33">\n			<span class="js-widget"  onclick=\'return new Widgets.Input({ bindingProperty: "number", label: L10N.get("pages.booking.bookingForm.cardNumber"), placeholder: L10N.get("pages.booking.bookingForm.cardNumber") })\'></span>\n		</div>\n\n		<div class="l-grid-layout-33">\n			<span class="b-person-bonus-card-railways__remove"></span>\n		</div>\n	</div>\n</div>\n';

}
return __p
}